/* ==========================================================================
   SearcherBusHotel > Calendar
   ========================================================================== */

/* Modules */
const CalendarClient = require('@bluekiri/alexandria-contrib-components/components/calendar/client/js');
const calendarHelper = require('../../../../helpers/calendar');

function initCalendar(selector, instance, configuration) {
    const config = configuration;
    config.onChange = [
        function fn() {
            const selectedDay = this.fp.selectedDateElem;
            // disabled day, you can't select the same date departure than return
            selectedDay.classList.add('disabled');
            selectedDay.blur();
        }
    ];

    const calendar = CalendarClient(selector, config);
    calendarHelper.setDefaultDates(instance, calendar);

    calendar.input.set(calendar.input.get());
    calendar.currentDates = calendar.get();
    calendar.fp.config.onClose = [
        () => {
            if (calendar.get().length === 0 || calendar.get().length === 1) {
                calendar.input.setActive();
                calendar.setDate(calendar.currentDates);
            }

            calendar.currentDates = calendar.get();
        }
    ];

    return calendar;
}

module.exports = {
    initCalendar
};
